/**
 * useCalGreen Hook
 * Calculates CalGreen compliance in real-time from waste streams
 */

import { useMemo } from 'react';
import { calculateCompliance, CALGREEN_DIVERSION_THRESHOLD } from '../utils/calgreen';
import type { WasteStream, ComplianceCalculation } from '../types';

interface UseCalGreenResult extends ComplianceCalculation {
  threshold: number;
  isCompliant: boolean;
  shortfall: number;
}

export function useCalGreen(wasteStreams: WasteStream[]): UseCalGreenResult {
  const compliance = useMemo(
    () => calculateCompliance(wasteStreams),
    [wasteStreams]
  );

  const shortfall = useMemo(() => {
    if (compliance.meets_calgreen_requirement) {
      return 0;
    }

    const requiredDiverted =
      (compliance.total_waste_generated * CALGREEN_DIVERSION_THRESHOLD) / 100;
    return Math.max(0, requiredDiverted - compliance.total_waste_diverted);
  }, [compliance]);

  return {
    ...compliance,
    threshold: CALGREEN_DIVERSION_THRESHOLD,
    isCompliant: compliance.meets_calgreen_requirement,
    shortfall,
  };
}